import { Point } from '../../../platform/geom/Point';
import { MouseButtons, MouseInput } from '../../../platform/input/MouseInput';
import { Camera } from '../../canvas/Camera';
import { defineToolWithCommonBehaviors } from '../../canvas/tooling/Definitions';
import { ToolBehavior } from '../../canvas/tooling/ToolBehavior';
import { ToolOverlay } from '../../canvas/tooling/ToolOverlay';
import { resolve } from '../../Container';
import { ParticleManager } from './ParticleManager';

type DragRegion = { from: Point, to: Point };

// const particleTip = HelpTip(
//     'annotate',
//     'videos',
//     'The Particle Pen',
//     'We\'ve recommended a tutorial video for you that covers the Vanishing Pen!'
// );

export class ParticleToolBehavior extends ToolBehavior {

    @resolve(Camera) private camera!: Camera;
    @resolve(ParticleManager) private particles!: ParticleManager;
    @resolve(ToolOverlay) private overlay!: ToolOverlay;

    private alive = true;
    private particleSince = null as number;
    private particleAt = null as Point;

    public init() {
        this.burden(() => this.alive = false);
    }

    public getPreferredCursor(state: string) {
        if (state === 'idle' || state === 'particling') {
            return 'crosshair';
        }
    }

    public onMouseDown(state: string, mi: MouseInput): string | void {
        if (state === 'idle' && mi.button === MouseButtons.Main) {
            this.particleSince = Date.now();
            this.particleAt = this.camera.toModel(mi.position);
            this.overlay.repaint();
            this.particles.fireEmojiCloud(this.particleAt, 1);
            return 'particling';
        }
    }

    public onMouseUp(state: string, mi: MouseInput): string | void {
        if (state === 'particling') {
            return 'idle';
        }
    }
}


export const particleTool = defineToolWithCommonBehaviors({
    id: 'particleTool',
    label: 'Particles',
    category: 'test',
    icon: 'deqo://icons/d2/particle',
    weight: 4035,
    shortcut: '3',
    behaviors: [
        ParticleToolBehavior,
    ]
});
